import {
  useAdvert as useGoogleAdvert,
  useAdverts as useGoogleAdverts
} from "../../client/googleAdverts";
import { useSelector } from "react-redux";
import {
  getAppLevelTargeting,
  getAdSpecificTargeting,
  getValidSlotSizes,
  getPriorProductsFingerprint,
  getAdUnitPath
} from "../../state/modules/adverts";
import config from "../../config/common";

const useAdvert = () => {
  const {
    adverts: {
      adId: id,
      scriptSrc,
      sizeMappings,
      fetchMarginPercent,
      renderMarginPercent,
      mobileMarginScaling
    }
  } = config;

  const adUnitPath = useSelector(getAdUnitPath);
  if (!adUnitPath) {
    return null;
  }

  if (CLIENT) {
    const appLevelTargeting = useSelector(getAppLevelTargeting);
    useGoogleAdverts({
      scriptSrc,
      fetchMarginPercent,
      renderMarginPercent,
      mobileMarginScaling,
      targeting: appLevelTargeting
    });

    const validSlotSizes = useSelector(getValidSlotSizes);
    const priorProductsFingerprint = useSelector(getPriorProductsFingerprint);
    const targeting = useSelector(getAdSpecificTargeting);
    useGoogleAdvert({
      id,
      sizeMappings,
      adUnitPath,
      targeting,
      validSlotSizes,
      priorSiblingsFingerprint: priorProductsFingerprint
    });
  }

  return id;
};

export default useAdvert;
